/**
 * Helper per Lazy Loading Routes
 * Converte i componenti in lazy-loaded chunks per ridurre bundle size
 */

/**
 * Lazy load un componente con chunk name personalizzato
 * @param {Function} importFunc - Funzione di import dinamico
 * @param {string} chunkName - Nome del chunk webpack
 * @returns {Function} Componente lazy-loaded
 */
export const lazyLoadComponent = (importFunc, chunkName = '') => {
  return {
    ...importFunc,
    displayName: chunkName,
  };
};

/**
 * Funzioni per lazy loading delle diverse sezioni
 */

// Admin - Lavorazioni
export const AdminLavorazioni = () => 
  import(/* webpackChunkName: "admin-lavorazioni" */ '@/pages/AdminLavorazioni.vue');

// Admin - Tickets
export const AdminTickets = () =>
  import(/* webpackChunkName: "admin-tickets" */ '@/pages/AdminTickets.vue');

// Admin - Pagamenti
export const AdminPagamenti = () =>
  import(/* webpackChunkName: "admin-pagamenti" */ '@/pages/AdminPagamenti.vue');

// Admin - Reportistica
export const AdminReport = () =>
  import(/* webpackChunkName: "admin-report" */ '@/pages/AdminReport.vue');

// Admin - Calendar
export const AdminCalendar = () =>
  import(/* webpackChunkName: "admin-calendar" */ '@/pages/AdminCalendar.vue');

// Admin - Documenti
export const AdminDocumenti = () =>
  import(/* webpackChunkName: "admin-documenti" */ '@/pages/AdminDocumenti.vue');

// Admin - Anagrafiche
export const AnagraficheList = () =>
  import(/* webpackChunkName: "admin-anagrafiche" */ '@/components/admin/pages/AnagraficheList.vue');

// Admin - Lavorazioni List
export const LavorazioniList = () =>
  import(/* webpackChunkName: "admin-lavorazioni" */ '@/components/admin/pages/LavorazioniList.vue');

// Admin - Lavorazione Dettaglio
export const LavorazioneDettaglio = () =>
  import(/* webpackChunkName: "admin-lavorazioni" */ '@/components/admin/pages/LavorazioneDettaglio.vue');

// Admin - Dispositivi
export const DispositiviList = () =>
  import(/* webpackChunkName: "admin-dispositivi" */ '@/components/admin/pages/DispositiviList.vue');

// Admin - Contratti
export const ContrattiList = () =>
  import(/* webpackChunkName: "admin-contratti" */ '@/components/admin/pages/ContrattiList.vue');

export const ContrattiTemplates = () =>
  import(/* webpackChunkName: "admin-contratti" */ '@/components/admin/pages/ContrattiTemplates.vue');

export const ContrattiAssign = () =>
  import(/* webpackChunkName: "admin-contratti" */ '@/components/admin/pages/ContrattiAssign.vue');

export const ContrattoDetail = () =>
  import(/* webpackChunkName: "admin-contratti" */ '@/components/admin/pages/ContrattoDetail.vue');

// Admin - Assistenza
export const AssistenzaList = () =>
  import(/* webpackChunkName: "admin-assistenza" */ '@/components/admin/pages/AssistenzaList.vue');

export const AssistenzaInternaForm = () =>
  import(/* webpackChunkName: "admin-assistenza" */ '@/components/admin/pages/AssistenzaInternaForm.vue');

// Admin - Tecnici
export const TecniciManagement = () =>
  import(/* webpackChunkName: "admin-tecnici" */ '@/components/admin/pages/TecniciManagement.vue');

// Admin - Users (Gestione Utenti)
export const AdminUsers = () =>
  import(/* webpackChunkName: "admin-users" */ '@/components/admin/pages/AdminUsers.vue');

// Admin - Fornitori
export const FornitoriList = () =>
  import(/* webpackChunkName: "admin-fornitori" */ '@/components/admin/pages/FornitoriList.vue');

// Admin - Settings
export const SettingsPage = () =>
  import(/* webpackChunkName: "admin-settings" */ '@/components/admin/pages/SettingsPage.vue');

// Admin - Technical Docs
export const TechnicalDocsPage = () =>
  import(/* webpackChunkName: "admin-docs" */ '@/components/admin/pages/TechnicalDocs.vue');

// Admin - Ticketing
export const TicketsList = () =>
  import(/* webpackChunkName: "admin-tickets" */ '@/pages/TicketsList.vue');

export const TicketDetail = () =>
  import(/* webpackChunkName: "admin-ticketing" */ '@/pages/TicketDetail.vue');

export const DashboardSla = () =>
  import(/* webpackChunkName: "admin-ticketing" */ '@/pages/DashboardSla.vue');

export const AuditLog = () =>
  import(/* webpackChunkName: "admin-ticketing" */ '@/pages/AuditLog.vue');

// ===== CLIENTE ROUTES =====

// Cliente - Dashboard
export const ClienteDashboard = () =>
  import(/* webpackChunkName: "cliente-dashboard" */ '@/pages/ClienteDashboard.vue');

// Cliente - Tickets
export const ClienteTickets = () =>
  import(/* webpackChunkName: "cliente-ticket" */ '@/pages/ClienteTickets.vue');

// Cliente - Interventi
export const ClienteInterventi = () =>
  import(/* webpackChunkName: "cliente-interventi" */ '@/pages/ClienteInterventi.vue');

// Cliente - Rapportini
export const ClienteRapportini = () =>
  import(/* webpackChunkName: "cliente-interventi" */ '@/pages/ClienteRapportini.vue');

// Cliente - Notifiche
export const ClienteNotifiche = () =>
  import(/* webpackChunkName: "cliente-notifiche" */ '@/pages/ClienteNotifiche.vue');

// Cliente - Supporto
export const ClienteSupportoTecnico = () =>
  import(/* webpackChunkName: "cliente-supporto" */ '@/pages/ClienteSupportoTecnico.vue');

// Cliente - Documenti
export const ClienteDocumenti = () =>
  import(/* webpackChunkName: "cliente-documenti" */ '@/pages/ClienteDocumenti.vue');

// Cliente - Ore Residue
export const ClienteOreResidue = () =>
  import(/* webpackChunkName: "cliente-ore" */ '@/pages/ClienteOreResidue.vue');

// Cliente - Profilo
export const ClienteProfilo = () =>
  import(/* webpackChunkName: "cliente-profilo" */ '@/pages/ClienteProfilo.vue');

// Cliente - Lavorazioni
export const ClienteLavorazioni = () =>
  import(/* webpackChunkName: "cliente-lavorazioni" */ '@/components/cliente/ClienteLavorazioni.vue');

export const ClienteLavorazioneDettaglio = () =>
  import(/* webpackChunkName: "cliente-lavorazioni" */ '@/components/cliente/ClienteLavorazioneDettaglio.vue');

// Cliente - Pagamenti
export const ClientePagamenti = () =>
  import(/* webpackChunkName: "cliente-pagamenti" */ '@/pages/ClientePagamenti.vue');

// ===== OTHER ROUTES =====

// Auth
export const LoginComponent = () =>
  import(/* webpackChunkName: "auth" */ '@/components/admin/authentication/LoginComponent.vue');

export const CompletaAnagrafica = () =>
  import(/* webpackChunkName: "auth" */ '@/pages/CompletaAnagrafica.vue');

// Landing
export const LandingPage = () =>
  import(/* webpackChunkName: "landing" */ '@/pages/LandingPageStandalone.vue');

export const ProgettoFinanziatoPage = () =>
  import(/* webpackChunkName: "progetto-finanziato" */ '@/pages/ProgettoFinanziatoPage.vue');

// Dashboard
export const DashboardPage = () =>
  import(/* webpackChunkName: "admin-dashboard" */ '@/components/admin/pages/DashboardPage.vue');

export const DummyView = () =>
  import(/* webpackChunkName: "admin-layout" */ '@/components/admin/dashboard/DummyView.vue');

// ===== LUCIDVUE COMPONENTS (template library) =====

export const CalendarComponent = () =>
  import(/* webpackChunkName: "lucidvue-calendar" */ '@/../lucidvue-3-admin/src/components/admin/app/CalendarComponent.vue');

export const ChatComponent = () =>
  import(/* webpackChunkName: "lucidvue-chat" */ '@/../lucidvue-3-admin/src/components/admin/app/ChatComponent.vue');

export const InboxComponent = () =>
  import(/* webpackChunkName: "lucidvue-inbox" */ '@/../lucidvue-3-admin/src/components/admin/app/InboxComponent.vue');

export const ContactGrideComponent = () =>
  import(/* webpackChunkName: "lucidvue-contacts" */ '@/../lucidvue-3-admin/src/components/admin/app/ContactGrideComponent.vue');

export const DocumentsComponent = () =>
  import(/* webpackChunkName: "lucidvue-files" */ '@/../lucidvue-3-admin/src/components/admin/filemanager/DocumentsComponent.vue');

export const FileMediaComponent = () =>
  import(/* webpackChunkName: "lucidvue-files" */ '@/../lucidvue-3-admin/src/components/admin/filemanager/FileMediaComponent.vue');

export const FileImageComponent = () =>
  import(/* webpackChunkName: "lucidvue-files" */ '@/../lucidvue-3-admin/src/components/admin/filemanager/FileImageComponent.vue');

export const InvoicesComponent = () =>
  import(/* webpackChunkName: "lucidvue-invoices" */ '@/../lucidvue-3-admin/src/components/admin/pages/InvoicesComponent.vue');

export const InvoicesTwoComponent = () =>
  import(/* webpackChunkName: "lucidvue-invoices" */ '@/../lucidvue-3-admin/src/components/admin/pages/InvoicesTwoComponent.vue');

export const PricingComponent = () =>
  import(/* webpackChunkName: "lucidvue-pricing" */ '@/../lucidvue-3-admin/src/components/admin/pages/PricingComponent.vue');

export const TeamsBoardComponent = () =>
  import(/* webpackChunkName: "lucidvue-teams" */ '@/../lucidvue-3-admin/src/components/admin/pages/TeamsBoardComponent.vue');

export const ProjectsListComponent = () =>
  import(/* webpackChunkName: "lucidvue-projects" */ '@/../lucidvue-3-admin/src/components/admin/pages/ProjectsListComponent.vue');

export const TimelineComponent = () =>
  import(/* webpackChunkName: "lucidvue-timeline" */ '@/../lucidvue-3-admin/src/components/admin/pages/TimelineComponent.vue');

export const ProfileComponent = () =>
  import(/* webpackChunkName: "lucidvue-profile" */ '@/../lucidvue-3-admin/src/components/admin/pages/ProfileComponent.vue');

export const SearchComponent = () =>
  import(/* webpackChunkName: "lucidvue-search" */ '@/../lucidvue-3-admin/src/components/admin/pages/SearchComponent.vue');

export const FaqComponent = () =>
  import(/* webpackChunkName: "lucidvue-faq" */ '@/../lucidvue-3-admin/src/components/admin/pages/FaqComponent.vue');

export const EChartsComponent = () =>
  import(/* webpackChunkName: "charts" */ '@/../lucidvue-3-admin/src/components/admin/charts/EChartsComponent.vue');

export const DataComponent = () =>
  import(/* webpackChunkName: "widgets" */ '@/../lucidvue-3-admin/src/components/admin/widgets/DataComponent.vue');

// Services & Providers pages
export const ServicesPage = () =>
  import(/* webpackChunkName: "services" */ '@/pages/ServicesPage.vue');

export const ProvidersPage = () =>
  import(/* webpackChunkName: "providers" */ '@/pages/ProvidersPage.vue');

export const ServiceDetail = () =>
  import(/* webpackChunkName: "service-detail" */ '@/pages/ServiceDetail.vue');

export const ServiceCreate = () =>
  import(/* webpackChunkName: "service-create" */ '@/pages/ServiceCreate.vue');

// Service Templates page
export const ServiceTemplatesPage = () =>
  import(/* webpackChunkName: "service-templates" */ '@/components/admin/pages/ServiceTemplates.vue');

export const ServiceCategoriesPage = () =>
  import(/* webpackChunkName: "service-categories" */ '@/components/admin/pages/ServiceCategories.vue');

export const ApiDocsPage = () =>
  import(/* webpackChunkName: "admin-api-docs" */ '@/components/admin/pages/ApiDocs.vue');

// Admin - Permessi
export const AdminPermissionsPage = () =>
  import(/* webpackChunkName: "admin-permissions" */ '@/pages/AdminPermissionsPage.vue');
